import {Component, 
	OnInit, 
	ElementRef, 
	ViewChildren, 
	ViewChild, 
	ChangeDetectionStrategy, 
	ChangeDetectorRef, 
	Inject, 
	ViewRef
}
from '@angular/core';
import { DatePipe } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// NGX
import { TranslateService } from '@ngx-translate/core';
// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
//Service
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { DeNghiMuaHangService } from '../de-nghi-mua-hang-service/de-nghi-mua-hang.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import { DeNghiMuaHang, DeNghiMuaHangCT } from '../de-nghi-mua-hang-model/de-nghi-mua-hang.model';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';

//Another
import moment from 'moment';
import { AddHangHoaComponent } from '../add-hang-hoa-dialog/add-hang-hoa-dialog.component';
import { TimKiemNangCaoListComponent } from '../../../../tim-kiem-nang-cao/tim-kiem-nang-cao.component';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { element } from 'protractor';

@Component({
selector: 'm-de-nghi-mua-hang-detail',
templateUrl: './de-nghi-mua-hang-detail.component.html',
styleUrls: ['../de-nghi-mua-hang.component.scss'],
changeDetection: ChangeDetectionStrategy.OnPush,
providers:[DatePipe]
})

export class DeNghiMuaHangDetailComponent implements OnInit {

	/*Config Form */
	CONFIG: CommonConFig;

	/* Các trường focus cho các tag trong form */
	@ViewChildren('focus') focus ;
	@ViewChildren('focusNCC') focusNCC;
	@ViewChildren('focusQC') focusQC;
	@ViewChildren('focusNVNH') focusNVNH;
	@ViewChildren('focusKho') focusKho;
	@ViewChildren('focusGhiChu') focusGhiChu;

	/* Comment columns mat-table
		Các trường columns cho bảng:
		- displayedColumns: display ra form
		- availableColumns: các cột sẽ được add vào display.
	*/
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'MaHang',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'TenHang',
			displayName: 'Tên hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'QuyCach',
			displayName: 'Quy cách',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'TenDVT',
			displayName: 'ĐVT',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'SoLuong',
			displayName: 'SL',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'PBSD',
			displayName: 'Phòng ban sử dụng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'NgayCan',
			displayName: 'Ngày cần',
			alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'GiaDuKien',
            displayName: 'Giá dự kiến (VND)',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'TenFileGoc',
            displayName: 'File đính kèm thông tin hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
			stt: 11,
			name: 'GhiChu',
			displayName: 'Ghi chú',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 12,
			name: 'NguoiDuyet',
			displayName: 'Người duyệt',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 13,
			name: 'NgayDuyet',
			displayName: 'Ngày duyệt',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 14,
			name: 'KetQuaDuyet',
			displayName: 'Kết quả duyệt',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 15,
			name: 'LyDo',
			displayName: 'Lý do',
			alwaysChecked: false,
			isShow: true
		},
		// {
		// 	stt: 14,
		// 	name: 'actions',
		// 	displayName: '',
		// 	alwaysChecked: false,
		// 	isShow: true
		// },
	];
	/* End comment columns mat-table -------------------------------------*/

	/* Danh sách trạng thái */
	listState : any[] = [];
	nameState: string = '';
	/* ------------------------------------------------------------------ */

	/* Danh sách phòng ban*/
	listPB : any[] = [];
	PBUser: string = '';   					//Tên phòng ban của user
	/* ------------------------------------------------------------------ */

	/* Mat select search cho hàng hóa */
	listId_HH : any[] = [];
	selectId_HH : string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;
	/* ------------------------------------------------------------------ */

	/* Mat select search cho nhà cung cấp */
	listNCC : any[] = [];
	selectListNCC : string = '';
	filteredListNCC: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListNCCFilterCtrl: string = '';
	haveElementListNCC: boolean = false;
	arrayNCCForEachHH: any[] = [];
	/* ------------------------------------------------------------------ */

	/* Mat select search cho phòng ban */
	listPBSD : any[] = [];
	selectListPBSD : string = '';
	filteredListPBSD: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListPBSDFilterCtrl: string = '';
	haveElementListPBSD: boolean = false;
	arrayPBSDForEachHH: any[] = [];
	/* ------------------------------------------------------------------ */

	/* Mat select cho loại phiếu */
	selectLoaiPhieu : string = 'NHUCAUPHATSINH';
	/* ------------------------------------------------------------------ */

	/* Selection */
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<DeNghiMuaHangCT>(true, []);
	/* ------------------------------------------------------------------ */

	/* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */

	/* Extend field:  */
	title: string = '';					// Tiêu đề dialog
	previousIndex: number; 				// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                 	// Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false;			// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	saveAddedDNMH: number[] = []		// Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = false;   	// Loading khi mở dialog
	canEdit: boolean = true;			// Dialog có thể chỉnh sửa không?
	sumTT: number = 0;					// Trường lưu tổng tiền
	disableNewButton: boolean = true;	// Tắt nút thêm mới hàng khi chưa nhập đủ
	flagButtonAdd: boolean = true; 		// Cờ để ẩn hiện nút lưu và thêm mới
	category_path: string = 'PDNMH'     // path lấy tình trạng phím
	hanMucPB: string = '0';
	/* ------------------------------------------------------------------ */

	/* Các Sub form trên dialog:  */
	DeNghiMuaHangForm: FormGroup;				//Form phiếu đề nghị
	hasFormErrors: boolean = false;

	DeNghiMuaHangSubForm: FormGroup;			//Form add hàng hóa cho phiếu
	hasSubFormErrors: boolean = false;
	/* ------------------------------------------------------------------ */

	/* Item dữ liệu từ của phiếu đề nghị khi mở dialog:  */
	deNghiMuaHangItem: DeNghiMuaHang;

	/* Danh sách chi tiết hàng hóa của phiếu đề nghị:  */
	listChiTietMuaHang: DeNghiMuaHangCT[] = [];

	/* Danh sách tạm chi tiết hàng hóa của phiếu đề nghị dùng để cập nhập trên lưới  */
	tmpChiTietMuaHang: DeNghiMuaHangCT[] = [];

	openTimKiemNangCao = false;

	waittingAddDetail = false;

	constructor(
		public dialogRef: MatDialogRef<DeNghiMuaHangDetailComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dungChungService: DungChungService,
		private deNghiMuaHangService: DeNghiMuaHangService,
		private DeNghiMuaHangFB: FormBuilder,
		private DeNghiMuaHangSubFB: FormBuilder,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private dialog: MatDialog,
		private layoutUtilsService: LayoutUtilsService,
		private el: ElementRef
	) {
		this.dialogRef.disableClose = true;
	}

	/*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {

		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		
		/*Get data from list when open dialog */
		this.deNghiMuaHangItem = this.data.data;

		/*Load title of dialog */
		this.title = this.getTitle();

		/*Load all dropdown and create form */
		//this.ListPB();
		this.layDanhSachPhongBan();
		this.ListId_HH();
		this.ListState();
		this.createForm();
		this.getHanMucPhongBan();
		

		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape" && !this.openTimKiemNangCao) {
				this.back();
			}
		});

		/* Filter list Hang hoa when value change*/
		this.DeNghiMuaHangSubForm.get('MaHang').valueChanges.subscribe(newValue=>{
			this.filterId_HH(newValue);
		})

		if(this.deNghiMuaHangItem.TinhTrang == DeNghiMuaHang.optionsTinhTrang[1].value){
			this.availableColumns.splice(0, 0, {
				stt: 0,
				name: 'select',
				displayName: 'Check chọn',
				alwaysChecked: true,
				isShow: true
			});
			this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		}

		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
	}
	ngAfterViewInit() {    
		/*Focus on first input field*/        
		if(this.focus != null && this.focus != undefined){
			setTimeout(() => this.focus.first.nativeElement.focus(), 500);
			this.changeDetectView();
		}
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Create Form with appropriate sub forms ---------------*/
	createForm(){

		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
		
		/*Group các Form */
		this.DeNghiMuaHangForm = this.DeNghiMuaHangFB.group({
			SoPhieu: [!(this.deNghiMuaHangItem.SoPhieu == undefined || this.deNghiMuaHangItem.SoPhieu == '') ? this.deNghiMuaHangItem.SoPhieu : '', Validators.required],
			NgayLapPhieu: [!(this.deNghiMuaHangItem.NgayYeuCau == undefined || this.deNghiMuaHangItem.NgayYeuCau == '') ? this.deNghiMuaHangItem.NgayYeuCau : new Date(), Validators.required],
			TenNguoiLap: [this.deNghiMuaHangItem.Id > 0 ? this.deNghiMuaHangItem.TenNguoiTao : tenNguoiLap,Validators.required],
			TrangThai: [this.nameState,Validators.required],
			// PBDeNghi: [this.PBUser,Validators.required],
			// NganSachCon: [this.hanMucPB],
			LoaiPhieu: [this.deNghiMuaHangItem.Id > 0 ? this.deNghiMuaHangItem.LoaiPhieu : this.selectLoaiPhieu, Validators.required],
			//NgayCan: [!(this.deNghiMuaHangItem.NgayDeNghiCoHang == undefined || this.deNghiMuaHangItem.NgayDeNghiCoHang == '') ? this.deNghiMuaHangItem.NgayDeNghiCoHang : new Date(), Validators.required],
			DienGiai: [!(this.deNghiMuaHangItem.DienGiaiLyDo == undefined || this.deNghiMuaHangItem.DienGiaiLyDo == '') ? this.deNghiMuaHangItem.DienGiaiLyDo : '',Validators.required]
		});

		/*Disable các trường dữ liệu không thay đổi */
		this.DeNghiMuaHangForm.controls["SoPhieu"].disable();
		this.DeNghiMuaHangForm.controls["NgayLapPhieu"].disable();
		this.DeNghiMuaHangForm.controls["TenNguoiLap"].disable();
		this.DeNghiMuaHangForm.controls["TrangThai"].disable();
		this.DeNghiMuaHangForm.controls["LoaiPhieu"].disable();
		this.DeNghiMuaHangForm.controls["DienGiai"].disable();
		/*------------------------------------------------------------------*/

		this.DeNghiMuaHangSubForm = this.DeNghiMuaHangSubFB.group({
			MaHang: ['',Validators.required],
			TenHang: [''],
			QuyCach: [''],
			DVT: [''],
			SoLuong:['0,00', Validators.compose([Validators.required, 
												Validators.min(0.01),
												Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER)])
					],
			PBSD : ['', Validators.required],
			NgayCan : [new Date(), Validators.required],
			GhiChu: [''],
		});
		/*Disable các trường dữ liệu không thay đổi */
		this.DeNghiMuaHangSubForm.controls["TenHang"].disable();
		this.DeNghiMuaHangSubForm.controls["QuyCach"].disable();
		this.DeNghiMuaHangSubForm.controls["DVT"].disable();
		/*------------------------------------------------------------------*/

		/*Add dữ liệu chi tiết cho các biến lưu nếu dialog ở trạng thái chỉnh sửa hoặc QC kiểm tra */
		if(this.deNghiMuaHangItem.Id > 0){
			this.listChiTietMuaHang = this.deNghiMuaHangItem.listChiTietMuaHang;
			this.tmpChiTietMuaHang = [];
			for(let i = 0; i < this.listChiTietMuaHang.length; i++){
				let tmpElement = new DeNghiMuaHangCT();
				tmpElement.copy(this.listChiTietMuaHang[i])
				if(tmpElement.FileImport != null){
					if(tmpElement.FileImport.filename != null && tmpElement.FileImport.filename != ''){
						let splitArray = tmpElement.FileImport.filename.split(".");
						if(splitArray.length == 2){
							tmpElement.FileImport.filename = splitArray[0];
							tmpElement.FileImport.extension = splitArray[1];
						}
					}
				}
				this.tmpChiTietMuaHang.push(tmpElement);
			}

			this.tmpChiTietMuaHang.forEach(x => {
				x.XuLy.PhieuDeNghi = x.PhieuDeNghiId;
				x.XuLy.PhieuDeNghiCT = x.Id;
				x.XuLy.LoaiThaoTac = x.XuLy.LoaiThaoTac;
				x.XuLy.TenNguoiDuyet = x.XuLy.TenNguoiDuyet;
				x.XuLy.NgayDuyetDate = x.XuLy.NgayDuyet? new Date(x.XuLy.NgayDuyet): null;
				x.XuLy.LyDo = x.XuLy.LyDo? x.XuLy.LyDo : '';
			})

			this.tmpChiTietMuaHang = [...this.tmpChiTietMuaHang];
		}
		/*------------------------------------------------------------------*/
		this.changeDetectView();
	}
	getTitle(): string {
		return 'CHI TIẾT PHIẾU ĐỀ NGHỊ MUA HÀNG';
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Hàm thông báo lỗi cho form tương ứng -----------------*/
	onAlertSubFormClose($event) {
		this.hasSubFormErrors = false;
	}
	onAlertFormClose($event) {
		this.hasFormErrors = false;
	}
	validateInvalidForm(){
		this.hasFormErrors = false;
		const controls = this.DeNghiMuaHangForm.controls;
		if (this.DeNghiMuaHangForm.invalid) {
			
			const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');
			if (invalidElements.length > 0) {
				for(let i = 0; i < invalidElements.length; i++){
					if(invalidElements[i].nodeName == 'INPUT' || invalidElements[i].nodeName == 'MAT-SELECT'){
						const elementControl = this.DeNghiMuaHangForm.get(invalidElements[i].attributes.getNamedItem("formcontrolname").value);
						if(elementControl){
							invalidElements[i].focus();
							break;
						}
					}
				}
			}
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			this.hasFormErrors = true;
			return false;
		}
		return true;
	}
	validateInvalidSubForm(isAddDetail: boolean = false){
		this.hasSubFormErrors = false;
		const controls = this.DeNghiMuaHangSubForm.controls;

		if (this.DeNghiMuaHangSubForm.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');

			if (invalidElements.length > 0) {
				for(let i = 0; i < invalidElements.length; i++){
					
					if(invalidElements[i].nodeName == 'INPUT' || invalidElements[i].nodeName == 'MAT-SELECT'){
						const elementControl = this.DeNghiMuaHangSubForm.get(invalidElements[i].attributes.getNamedItem("formcontrolname").value);
						if(elementControl){
							invalidElements[i].focus();
							break;
						}
					}
				}
			}
			Object.keys(controls).forEach(controlName =>{
				controls[controlName].markAsTouched()
			});
			this.hasSubFormErrors = true;
			return false;
		}

		if(!isAddDetail){
			this.forcusAnotherEmptyField(controls);
		}
		return true;
	}
	/* -----------------------------------------------------------------------*/


	/*--------- Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng------*/
	showColumnsInTable(){
		for(let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].isShow == false){
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string){
		for( let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------- Hàm lấy danh sách-----------------------------*/
	ListState(){
		this.dungChungService.listState(this.category_path).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listState = res.data;
				this.checkState();
				this.changeDetectView();
			};
		});
	}
	checkState(){
		this.listState.forEach(element => {
			if(element.Code == this.deNghiMuaHangItem.TinhTrang){
				this.nameState = element.Description;
				if(this.DeNghiMuaHangForm != null)
					this.DeNghiMuaHangForm.controls["TrangThai"].setValue(this.nameState);
			}
				
		});
	}

	ListId_HH(){
		this.dungChungService.listHangHoa().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.changeDetectView();
			};
		});
	}
	filterId_HH(searchTmp: string = '') {
		if (!this.listId_HH) {
			return;
		}
		// get the search keyword
		let search = this.Id_HHFilterCtrl;
		if(searchTmp != '' && searchTmp != null)
			search = '' + searchTmp;

		if (!search) {
			this.filteredId_HH.next(this.listId_HH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		if(searchTmp != ''){
			this.filteredId_HH.next(
				this.listId_HH.filter(ts => 
					ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1)
			);
		}
		else{
			this.filteredId_HH.next(
				this.listId_HH.filter(ts => 
					ts.MaHang.toLowerCase().indexOf(search) > -1)
			);
		}
		
		this.changeDetectView();
	}
	afterSelectHH(value:string){
		this.listId_HH.forEach( element => {
			if(element.Id_HH == +value){
				this.selectId_HH = value;
				this.DeNghiMuaHangSubForm.controls["MaHang"].setValue(element.MaHH);
				this.DeNghiMuaHangSubForm.controls["MaHang"].disable();
				this.DeNghiMuaHangSubForm.controls["TenHang"].setValue(element.TenHH);
				this.DeNghiMuaHangSubForm.controls["QuyCach"].setValue(element.QuyCach);
				this.DeNghiMuaHangSubForm.controls["DVT"].setValue(element.TenDVT);
				this.validateInvalidSubForm();
			}
		});
		this.isDisableButton();
	}
	clearSelectHH(event: any){
		this.selectId_HH = '';
		this.DeNghiMuaHangSubForm.controls["MaHang"].setValue('');
		this.DeNghiMuaHangSubForm.controls["MaHang"].enable();

		this.DeNghiMuaHangSubForm.controls["TenHang"].setValue('');
		this.DeNghiMuaHangSubForm.controls["QuyCach"].setValue('');
		this.DeNghiMuaHangSubForm.controls["DVT"].setValue('');
		this.isDisableButton();
		event.stopPropagation();
	}
	ChangeHH(){
		this.listId_HH.forEach( element => {
			if(element.Id_HH == this.selectId_HH){
				this.DeNghiMuaHangSubForm.controls["MaHang"].setValue(element.MaHang)
			}
		})
	}

	// ListPB(){
	// 	this.dungChungService.listPB().subscribe(res => {
	// 		this.loadingSubject.next(false);
	// 		if (res && res.status === 1) {
	// 			this.listPB = res.data;

	// 			var phongban = '';
	// 			this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });

	// 			if(this.deNghiMuaHangItem.Id > 0){
	// 				this.listPB.forEach(element => {
	// 					if(element.Id_PB == +this.deNghiMuaHangItem.PhongBanId){
	// 						this.PBUser = element.TenPB;
	// 					}
	// 				})
	// 			}
	// 			else{
	// 				this.listPB.forEach(element => {
	// 					if(element.Id_PB == +phongban){
	// 						this.PBUser = element.TenPB;
	// 					}
	// 				})
	// 			}
	// 			this.DeNghiMuaHangForm.controls["PBDeNghi"].setValue(this.PBUser)
	// 			this.changeDetectView();
	// 		};
	// 	});
	// }

	getHanMucPhongBan(){
		var phongban = '';
		if(this.deNghiMuaHangItem.Id > 0){
			phongban = this.deNghiMuaHangItem.PhongBanId.toString();
		}
		else{
			this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });
		}	
		this.dungChungService.getHanMucPhongBan(+phongban).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.hanMucPB = res.data;
				if(this.hanMucPB == null || this.hanMucPB == '')
					this.hanMucPB = '0'
				this.DeNghiMuaHangForm.controls["NganSachCon"].setValue(this.f_currency_V2((this.hanMucPB)));
			};
		});
	}
	changeLoaiPhieu(){
		if(this.DeNghiMuaHangForm.controls["LoaiPhieu"].value == DeNghiMuaHang.optionsLoaiPhieu[0].value){
			this.DeNghiMuaHangForm.controls["NganSachCon"].setValue(this.f_currency_V2((this.hanMucPB)));
		}
		else if(this.DeNghiMuaHangForm.controls["LoaiPhieu"].value == DeNghiMuaHang.optionsLoaiPhieu[1].value ||
					this.DeNghiMuaHangForm.controls["LoaiPhieu"].value == DeNghiMuaHang.optionsLoaiPhieu[2].value){
						this.DeNghiMuaHangForm.controls["NganSachCon"].setValue('0');
		}
	}
	/* -----------------------------------------------------------------------*/


	/*--------- Các hàm hỗ trợ cho thay đổi - cập nhập dữ liệu trên bảng------*/
	// changeValueOfColumn(columnName:string, item:any, event: any, afterUpdate: boolean){
		
	// 	if(columnName == 'SoLuong'){
	// 		if(afterUpdate)
	// 			this.listChiTietMuaHang[this.tmpChiTietMuaHang.indexOf(item)].SoLuong = this.formatNumber(item.SoLuong);
	// 		else if(!afterUpdate && this.ValidateChangeNumberEvent(columnName,item,event)){
	// 			this.tmpChiTietMuaHang[this.tmpChiTietMuaHang.indexOf(item)].SoLuong = '' + Number(event.target.value.trim().replace(/,/g, ""));
	// 			this.updateValueColumn('SoLuong',item);
	// 		}
	// 	}

	// 	if(columnName == 'GhiChu'){
	// 		if(afterUpdate)
	// 			this.listChiTietMuaHang[this.tmpChiTietMuaHang.indexOf(item)].GhiChu = item.GhiChu
	// 		else if(!afterUpdate){
	// 			this.tmpChiTietMuaHang[this.tmpChiTietMuaHang.indexOf(item)].GhiChu = event.target.value.trim();
	// 			this.updateValueColumn('GhiChu',item);
	// 		}
	// 	}
	// }
	isChangeValueOfColumn(columnName:string, item:any){
		if(columnName == 'GhiChu' && this.tmpChiTietMuaHang[this.tmpChiTietMuaHang.indexOf(item)].GhiChu != this.listChiTietMuaHang[this.tmpChiTietMuaHang.indexOf(item)].GhiChu)
			return true;
		if(columnName == 'SoLuong' && this.tmpChiTietMuaHang[this.tmpChiTietMuaHang.indexOf(item)].SoLuong != this.listChiTietMuaHang[this.tmpChiTietMuaHang.indexOf(item)].SoLuong)
			return true;

		return false;
	}
	// updateValueColumn(columnName:string, item:any){
	// 	this.changeValueOfColumn(columnName,item,null,true);
	// 	const message = `Cập nhật thành công`;
	// 	this.layoutUtilsService.showInfo(message);

	// 	this.tmpChiTietMuaHang = [];
	// 	for(let i = 0; i < this.listChiTietMuaHang.length; i++){
	// 		let tmpElement = new DeNghiMuaHangCT();
	// 		tmpElement.copy(this.listChiTietMuaHang[i])
	// 		this.tmpChiTietMuaHang.push(tmpElement);
	// 	}

	// 	this.tmpChiTietMuaHang = [...this.tmpChiTietMuaHang];
	// 	this.focusEvents();
	// }
	resetValueUpdate(columnName:string, item:any){
		if(columnName == 'SoLuong'){
			this.tmpChiTietMuaHang[this.tmpChiTietMuaHang.indexOf(item)].SoLuong =  this.listChiTietMuaHang[this.tmpChiTietMuaHang.indexOf(item)].SoLuong;
		}
		if(columnName == 'GhiChu'){
			this.tmpChiTietMuaHang[this.tmpChiTietMuaHang.indexOf(item)].GhiChu =  this.listChiTietMuaHang[this.tmpChiTietMuaHang.indexOf(item)].GhiChu;
		}
	}
	ValidateChangeNumberEvent(columnName:string, item:any, event: any) {
		var count = 0;
		for(let i = 0; i < event.target.value.length; i++){
			if(event.target.value[i] == '.'){
				count += 1;
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	changeValueOfForm(controlName: string, event: any, type: number){
		if( type == 1){
			if(this.ValidateChangeNumberForm(event)){
				let tmpValue = this.DeNghiMuaHangForm.controls[controlName].value.replace(/,/g, "");
				this.DeNghiMuaHangForm.controls[controlName].setValue(
						this.f_currency_V2(tmpValue)
				);
			}
			else{
				this.DeNghiMuaHangForm.controls[controlName].setValue(event.target.value);
			}
		}
		else if(type == 2){
			if(this.ValidateChangeNumberForm(event)){
				let tmpValue = this.DeNghiMuaHangSubForm.controls[controlName].value.replace(/,/g, "");
				this.DeNghiMuaHangSubForm.controls[controlName].setValue(
						this.f_currency(this.formatNumber(tmpValue))
				);
			}
			else{
				this.DeNghiMuaHangSubForm.controls[controlName].setValue(event.target.value);
			}
			this.isDisableButton();
		}
	}
	/* -----------------------------------------------------------------------*/


	/*------------------ Hàm hỗ trợ format các dạng số trên form -------------*/
	ValidateChangeNumberForm(event: any, isEvent:boolean = true) {
		var count = 0;
		if(isEvent){
			for(let i = 0; i < event.target.value.length; i++){
				if(event.target.value[i] == '.'){
					count += 1;
				}
			}
		}
		else{
			event = "" + event
			for(let i = 0; i < event.length; i++){
				if(event[i] == '.'){
					count += 1;
				}
			}
		}
		;
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string){
		if(item == '' || item == null || item == undefined)	return '';
		if(typeof(item) === "string"){
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-'+ this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
	getFormatDate(v: string = '') {
		if (v != null && v!= undefined && v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	/* -----------------------------------------------------------------------*/


	/*---------------------------- Thao tác trên form ------------------------*/
	isDisableButton(){
		if( this.DeNghiMuaHangSubForm.invalid || 
			this.DeNghiMuaHangSubForm.controls["TenHang"].value == null || 
			this.DeNghiMuaHangSubForm.controls["TenHang"].value == ''){
				this.disableNewButton = true;
		}
		else{
			this.disableNewButton = false;
		}
	}
	closeDropdownHangHoaEvent(dropdownName: string){
		if(dropdownName == 'NCC'){
			this.focusNCC.first.close();
			this.changeDetectView();
		}

		this.hasSubFormErrors = false;
		this.validateInvalidSubForm();
		this.changeDetectView();
	}
	changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	back(){
		this.dialogRef.close(
			{ 
				isChange: this.isChange,		//Dữ liệu có thay đổi hay không?
				dataAdd : this.saveAddedDNMH 	//highlight ID
			}
		);
	}
	deleteItem(item: any){
		const index = this.tmpChiTietMuaHang.indexOf(item, 0);
		if (index > -1) {
			this.listChiTietMuaHang.splice(index, 1);
		}
		this.tmpChiTietMuaHang = [];
		for(let i = 0; i < this.listChiTietMuaHang.length; i++){
			let tmpElement = new DeNghiMuaHangCT();
			tmpElement.copy(this.listChiTietMuaHang[i])
			this.tmpChiTietMuaHang.push(tmpElement);
		}

		this.tmpChiTietMuaHang = [...this.tmpChiTietMuaHang];
	}
	addMoreHH(event: any){
		const dialogRef = this.dialog.open(AddHangHoaComponent, {
			data: null,
			width: '60%',
		});

		dialogRef.afterClosed().subscribe(res => {
			
			if (res == undefined || res == null) {
				return;
			}
			else {
				if(res.data != null && res.data != undefined){
					this.ListId_HH();
					this.selectId_HH = res.data.Id_HH;
					this.DeNghiMuaHangSubForm.controls["MaHang"].setValue(res.data.MaHH);
					this.DeNghiMuaHangSubForm.controls["MaHang"].disable();
					this.DeNghiMuaHangSubForm.controls["TenHang"].setValue(res.data.TenHH);
					this.DeNghiMuaHangSubForm.controls["DVT"].setValue(res.data.TenDVT);
					this.validateInvalidSubForm();
					this.isDisableButton();
				}
			}
		});
	}
	addDetail(){
		this.waittingAddDetail = true;
		this.hasSubFormErrors = false;
		const controls = this.DeNghiMuaHangSubForm.controls;

		if(!this.validateInvalidSubForm(true))
			return null;

		if(!this.ValidateChangeNumberForm(this.DeNghiMuaHangSubForm.controls['SoLuong'].value,false)){
			return null;
		} 

		const _detail = new DeNghiMuaHangCT();
		_detail.clear();

		this.listId_HH.forEach( element => {
			if(element.Id_HH == +this.selectId_HH){
				_detail.MaHang = element.MaHH;
				_detail.TenHang = element.TenHH;
				_detail.QuyCach = element.QuyCach;
				_detail.TenDVT = element.TenDVT;
				_detail.Dvt = element.DVT;
			}
		})

		_detail.HangHoaId = +this.selectId_HH;
		_detail.SoLuong = this.formatComparenumber(controls['SoLuong'].value.toString());
		_detail.IdPBSD = Number(controls['PBSD'].value);
		_detail.TenPBSD = this.listPBSD.findIndex(x => x.Id_PB == _detail.IdPBSD) > -1 ?  this.listPBSD.find(x => x.Id_PB == _detail.IdPBSD).TenPB : '';
		_detail.NgayCan =  moment(new Date(controls["NgayCan"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		_detail.GhiChu = controls["GhiChu"].value;

		// const message = `Thông tin hàng về mới đã được thêm.`;
		// this.layoutUtilsService.showInfo(message);

		this.DeNghiMuaHangSubForm.reset();
		this.DeNghiMuaHangSubForm.controls["SoLuong"].setValue('0,00');
		this.DeNghiMuaHangSubForm.controls["NgayCan"].setValue(new Date());
		this.DeNghiMuaHangSubForm.controls["MaHang"].enable(); //Open field when reset

		this.selectId_HH = '';
		//Reset mat autocomplete to select
		this.filteredId_HH.next(this.listId_HH.slice());

		let isContain = false;
		this.listChiTietMuaHang.forEach(element =>{
			if(_detail.HangHoaId == element.HangHoaId){
				element.SoLuong = (Number(_detail.SoLuong) + Number(element.SoLuong));
				isContain = true;
			}
		})
		if(!isContain){
			this.listChiTietMuaHang.push(_detail);
		}

		this.tmpChiTietMuaHang = [];
		for(let i = 0; i < this.listChiTietMuaHang.length; i++){
			let tmpElement = new DeNghiMuaHangCT();
			tmpElement.copy(this.listChiTietMuaHang[i])
			this.tmpChiTietMuaHang.push(tmpElement);
		}

		this.tmpChiTietMuaHang = [...this.tmpChiTietMuaHang];
		this.disableNewButton = true;
		this.waittingAddDetail = false;
		this.focusEvents();
	}
	onSubmit(type: number) {
		
		this.hasFormErrors = false;
		const controls = this.DeNghiMuaHangForm.controls;

		if(!this.validateInvalidForm())
			return null;

		if (this.listChiTietMuaHang.length <= 0) {
			this.layoutUtilsService.showErorr('Vui lòng thêm thông tin hàng cần mua');
			return null;
		}

		var phongban = '';
		this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });

		const _result = new DeNghiMuaHang();
		_result.clear();
		_result.SoPhieu = controls["SoPhieu"].value;
		_result.LoaiPhieu = controls["LoaiPhieu"].value;
		_result.LoaiHangHoaYeuCau = 3;
		//_result.NgayDeNghiCoHang = moment(new Date(controls["NgayCan"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		_result.NgayYeuCau = moment(new Date(controls["NgayLapPhieu"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		//_result.PhongBanId = +phongban;
		_result.DienGiaiLyDo = controls["DienGiai"].value;
		_result.Ngaytao = moment(new Date(controls["NgayLapPhieu"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS'); // tmp Value but insert today in API
		_result.TinhTrang = DeNghiMuaHang.optionsTinhTrang[0].value;
		this.tmpChiTietMuaHang.forEach(x =>{
			x.SoLuong = this.formatComparenumber(x.SoLuong.toString());
		})
		_result.listChiTietMuaHang = this.tmpChiTietMuaHang;
		if(type == 1 || type == 2){
			_result.TinhTrang = DeNghiMuaHang.optionsTinhTrang[1].value;
		}

		if(type == 1 || type == 2){
			const dialogRef = this.layoutUtilsService.POP02(_result.SoPhieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				if (this.deNghiMuaHangItem.Id > 0) {
					_result.Id = this.deNghiMuaHangItem.Id;
					this.updatePhieuDeNghiMuaHang(_result,type);
					return;
				}
				this.addPhieuDeNghiMuaHang(_result,type);
			});
		}
		else{
			if (this.deNghiMuaHangItem.Id > 0) {
				_result.Id = this.deNghiMuaHangItem.Id;
				this.updatePhieuDeNghiMuaHang(_result,type);
					return;
			}
			this.addPhieuDeNghiMuaHang(_result,type);
		}
	}
	updatePhieuDeNghiMuaHang(item: DeNghiMuaHang, withBack: number) {
		this.deNghiMuaHangService.updateDeNghiMuaHangWithDetail(item).subscribe(res => {
			if (res.status == 1) {

				const message = `Phiếu đề nghị mua hàng cập nhật thành công`;
				this.layoutUtilsService.showInfo(message);
				
				let index = this.saveAddedDNMH.findIndex(x => x == res.data.Id);
				if(index == -1)
					this.saveAddedDNMH.push(res.data.Id);
				this.isChange = true;
				
				if(withBack == 1){
					this.back();
				}
				else{
					this.DeNghiMuaHangForm.controls["TrangThai"].setValue(DeNghiMuaHang.optionsTinhTrang[0].name);
					if(withBack == 2){
						this.dungChungService.getBillNumber(this.category_path).subscribe(resSP => {
							if (resSP.status == 1) {
								var tenNguoiLap = '';
								this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

								this.DeNghiMuaHangForm.reset();
								this.DeNghiMuaHangForm.controls["SoPhieu"].setValue(resSP.data);
								this.DeNghiMuaHangForm.controls["NgayLapPhieu"].setValue(new Date());
								this.DeNghiMuaHangForm.controls["TenNguoiLap"].setValue(tenNguoiLap);
								this.DeNghiMuaHangForm.controls["TrangThai"].setValue(DeNghiMuaHang.optionsTinhTrang[0].name);
								//this.DeNghiMuaHangForm.controls["NgayCan"].setValue(new Date());
								//this.DeNghiMuaHangForm.controls["PBDeNghi"].setValue(this.PBUser);
								this.selectLoaiPhieu = 'NHUCAUPHATSINH';
								this.DeNghiMuaHangForm.controls["LoaiPhieu"].setValue(this.selectLoaiPhieu);
								this.getHanMucPhongBan();

								this.DeNghiMuaHangForm.controls["SoPhieu"].disable();
								this.DeNghiMuaHangForm.controls["NgayLapPhieu"].disable();
								this.DeNghiMuaHangForm.controls["TenNguoiLap"].disable();
								this.DeNghiMuaHangForm.controls["TrangThai"].disable();
								// this.DeNghiMuaHangForm.controls["PBDeNghi"].disable();

								this.DeNghiMuaHangSubForm.reset();
								this.DeNghiMuaHangSubForm.controls["MaHang"].enable();
								this.DeNghiMuaHangSubForm.controls["SoLuong"].setValue('0,00');
								this.DeNghiMuaHangSubForm.controls["NgayCan"].setValue(new Date());
								this.DeNghiMuaHangSubForm.controls["PBSD"].setValue('');
								this.selectId_HH = '';
								this.filteredId_HH.next(this.listId_HH.slice());
				
								this.listChiTietMuaHang = [];
								this.tmpChiTietMuaHang = [];
								this.tmpChiTietMuaHang = [...this.tmpChiTietMuaHang];

								this.deNghiMuaHangItem.Id = 0;
								this.deNghiMuaHangItem.SoPhieu = resSP.data;
								this.title = this.getTitle();

								this.focusEvents();
							}
							else {
								const message = `Lỗi lấy số phiếu tiếp theo`;
								this.layoutUtilsService.showErorr(message);
							}
						});
					}
				}
				this.focusEvents();
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	addPhieuDeNghiMuaHang(item: DeNghiMuaHang, withBack: number){
		this.deNghiMuaHangService.addDeNghiMuaHang(item).subscribe(res => {
			if (res.status == 1) {		
				const message = `Phiếu đề nghị mua hàng mới đã được thêm.`;
				this.layoutUtilsService.showInfo(message);

				let index = this.saveAddedDNMH.findIndex(x => x == res.data.Id);
				if(index == -1)
					this.saveAddedDNMH.push(res.data.Id);
				this.isChange = true;

				if(withBack == 1){
					this.back();
				}
				else{
					this.selectId_HH = '';
					//Reset mat autocomplete to select
					this.filteredId_HH.next(this.listId_HH.slice());
					if(withBack == 2){
						this.dungChungService.getBillNumber(this.category_path).subscribe(res => {
							if (res.status == 1) {
								var tenNguoiLap = '';
								this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

								this.DeNghiMuaHangForm.reset();
								this.DeNghiMuaHangForm.controls["SoPhieu"].setValue(res.data);
								this.DeNghiMuaHangForm.controls["NgayLapPhieu"].setValue(new Date());
								this.DeNghiMuaHangForm.controls["TenNguoiLap"].setValue(tenNguoiLap);
								this.DeNghiMuaHangForm.controls["TrangThai"].setValue(DeNghiMuaHang.optionsTinhTrang[0].name);
								//this.DeNghiMuaHangForm.controls["NgayCan"].setValue(new Date());
								//this.DeNghiMuaHangForm.controls["PBDeNghi"].setValue(this.PBUser);
								this.selectLoaiPhieu = 'NHUCAUPHATSINH';
								this.DeNghiMuaHangForm.controls["LoaiPhieu"].setValue(this.selectLoaiPhieu);
								this.getHanMucPhongBan();
								
								this.DeNghiMuaHangForm.controls["SoPhieu"].disable();
								this.DeNghiMuaHangForm.controls["NgayLapPhieu"].disable();
								this.DeNghiMuaHangForm.controls["TenNguoiLap"].disable();
								this.DeNghiMuaHangForm.controls["TrangThai"].disable();
								//this.DeNghiMuaHangForm.controls["PBDeNghi"].disable();

								this.DeNghiMuaHangSubForm.reset();
								this.DeNghiMuaHangSubForm.controls["MaHang"].enable();
								this.DeNghiMuaHangSubForm.controls["SoLuong"].setValue('0,00');
								this.DeNghiMuaHangSubForm.controls["NgayCan"].setValue(new Date());
								this.DeNghiMuaHangSubForm.controls["PBSD"].setValue('');
								
								this.listChiTietMuaHang = [];
								this.tmpChiTietMuaHang = [];
								this.tmpChiTietMuaHang = [...this.tmpChiTietMuaHang];
								
								this.deNghiMuaHangItem.SoPhieu = res.data;
								this.focusEvents();
							}
							else {
								const message = `Lỗi lấy số phiếu tiếp theo`;
								this.layoutUtilsService.showErorr(message);
							}
						});
					}
					else if(withBack == 3){
						this.DeNghiMuaHangForm.controls["TrangThai"].setValue(DeNghiMuaHang.optionsTinhTrang[0].name);
						this.deNghiMuaHangItem.Id = res.data.Id;
					}
					this.title = this.getTitle();
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	updateState(){
		this.deNghiMuaHangItem.listChiTietMuaHang.forEach(element =>{
			let tmp = this.selection.selected.find(x => x.Id == element.Id)
			if(tmp != null){
				element.DaNhanHang = true;
			}
		})
		this.deNghiMuaHangService.updateStateNH(this.deNghiMuaHangItem).subscribe(res => {
			if (res.status == 1) {		
				const message = `Phiếu đề nghị mua hàng đã được cập nhật`;
				this.layoutUtilsService.showInfo(message);

				let index = this.saveAddedDNMH.findIndex(x => x == res.data.Id);
				if(index == -1)
					this.saveAddedDNMH.push(res.data.Id);
				this.isChange = true;
				this.deNghiMuaHangItem.TinhTrang = res.data.TinhTrang;

				this.selection.selected.forEach(element =>{
					element.DaNhanHang = true;
				})
				this.ListState();
				this.createForm();	
				this.changeDetectView();
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	timKiemNangCao(){
		this.openTimKiemNangCao = true;
		
		const dialogRef = this.dialog.open(TimKiemNangCaoListComponent, {
			data: {
				kw : this.focus.first.nativeElement.value
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			this.openTimKiemNangCao = false;
			if (res == undefined || res == null) {
				return;
			}
			else{
				if (!res.isChange) {
					return;
				}
				if(res.dataAdd.length != 0){
					this.afterSelectHH(res.dataAdd.toString())
				}
			}
		});
	}
	isAllSelected() {
		let numSelected = 0;
		let numRows = 0;
		this.selection.selected.forEach(element =>{
			if(!element.DaNhanHang){
				numSelected++;
			}
		})
		this.tmpChiTietMuaHang.forEach(element =>{
			if(!element.DaNhanHang && element.XuLy.TenLoaiThaoTac == 'Duyệt'){
				numRows++;
			}
		})
		return numSelected === numRows;
	}
	masterToggle() {
		if (this.isAllSelected()) {
			this.selection.clear();
		} else {
			this.tmpChiTietMuaHang.forEach(element => {
				if(!element.DaNhanHang && element.XuLy.TenLoaiThaoTac == 'Duyệt'){
					this.selection.select(element)
				}		
			});
		}
	}
	checkDisableButton(){
		let isContainChuaNhan = false;
		if(this.selection.selected.length > 0){
			this.selection.selected.forEach(element =>{
				if(!element.DaNhanHang){
					isContainChuaNhan = true;
				}
			})
			if(isContainChuaNhan)
				return false;
			return true;
		}
		else
			return true;
	}
	checkAllRecordCheckbox(){
		let condition = true;
		this.tmpChiTietMuaHang.forEach(element => {	
			if(!element.DaNhanHang && element.XuLy.TenLoaiThaoTac == 'Duyệt'){
				condition = false;
			}
		});

		if(!condition)
			return false
		return true;
	}
	downloadFile(idctdn: number) {
		let linkdownload = this.deNghiMuaHangService.downloadTemplate(idctdn);
		window.open(linkdownload);
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------------- Focus form -----------------------------*/
	focusWhenEscapseDropDown(nameDropDown: string){
		if(nameDropDown == 'NVHH'){
			this.focusGhiChu.first.nativeElement.focus();
		}
		this.changeDetectView();
	}
	forcusAnotherEmptyField(control: any){
		Object.keys(control).forEach(controlName =>{
			
			if(control[controlName].value == null || control[controlName].value == undefined
							|| control[controlName].value == ''){
			
				if(controlName == 'GhiChu'){
					this.focusGhiChu.first.nativeElement.focus();
				}
			}

			this.changeDetectView();
		});
	}
	focusEvents(){
		if(this.focus != null && this.focus != undefined){
			setTimeout(() => this.focus.first.nativeElement.focus(), 500);
			this.changeDetectView();
		}
	}
	isCreate(){
		
		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		let element = this.deNghiMuaHangItem;
		if(element != null && (element.Nguoitao == +idUser || element.NguoiYeuCau == +idUser )){
			return true;
		}
		return false;
	}
	/* -----------------------------------------------------------------------*/


	async layDanhSachPhongBan(){
		let res = await this.dungChungService.listPhongBanAll().toPromise();
		if(res && res.status === 1){
			this.listPBSD = res.data;
			this.filteredListPBSD.next(this.listPBSD.slice());
			this.changeDetect.detectChanges();
		}else{
			this.layoutUtilsService.showErorr(res.error.message);
		}
		this.changeDetect.detectChanges();
	}

	filterListPBSD() {
		if (!this.listPBSD) {
			return;
		}
		// get the search keyword
		let search = this.ListPBSDFilterCtrl;
		if (!search) {
			this.filteredListPBSD.next(this.listPBSD.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListPBSD.next(
			this.listPBSD.filter(ts =>
				ts.TenPB.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}

	keyUpInputNumberVND(event){
		FunctionPublic.preventAlphaV2(event);
	}

	changeInputNumberVND(event, columnName, min: number = 0, formGroup){
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) { 
			event.preventDefault(); 
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) 
			{ return; } 

			let data = FunctionPublic.slListChangedV2(event);
			if(data){
				if(this.formatComparenumber(data) < min && event.data && event.data == '0') data = this.f_currency_VND(this.formatNumber(min.toString()));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				
			}else{
				controls[columnName].setValue(this.f_currency_VND(this.formatNumber(min.toString())));
			}
		}
	}

	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return '0,00';
		return new Intl.NumberFormat('de-DE',{ style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}

	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup){
		let controls = formGroup.controls;
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");
			
			if(Number(tmpValue) < min) tmpValue = min;

			if(!controls[controlName].invalid){
				controls[controlName].setValue(
					this.f_currency_VND(this.formatNumber(tmpValue))
				);
			}
			if(tmpValue.indexOf(',') == 0 && tmpValue.length == 1){
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_currency_VND(this.formatNumber(tmpValue))
			);
		}
		else{
			controls[controlName].setValue(this.f_currency_VND(this.formatNumber(min.toString())));
			//console.log(controls[controlName].value);
		}
	}

	formatComparenumber(number: string){
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}

	dateToDDMMYYYY(__data: any){
		let __date = new Date(__data);
		return ("0" + __date.getDate()).slice(-2)+"/"+("0" + (__date.getMonth() + 1)).slice(-2)+"/"+__date.getFullYear();
	}
}
